import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import pageRepository from '@/features/pages/repositories/PageRepository';
import type { OrderOption } from '@/features/pages/types/page.types';
import { pageKeys } from '@/shared/query/queryKeys';

type UsePagesMetadataOptions = {
  orderBy?: OrderOption;
  filters?: readonly string[];
  enabled?: boolean;
};

export function usePagesMetadata({
  orderBy = 'updatedAt',
  filters = [],
  enabled = true,
}: UsePagesMetadataOptions = {}) {
  const query = useQuery({
    queryKey: pageKeys.metadata(orderBy),
    queryFn: () => pageRepository.getPagesMetadata(orderBy),
    enabled,
  });

  const filteredData = useMemo(() => {
    const pages = query.data ?? [];
    if (!filters.length) return pages;

    const filterSet = new Set(filters);
    return pages.filter(page => page.tags?.some(tag => filterSet.has(tag)));
  }, [filters, query.data]);

  return {
    ...query,
    data: filteredData,
  };
}
